import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'sa-eet',
  template: require('./eet.component.html'),
  styles: [require('./eet.component.scss')]
})
export class EetComponent implements OnInit {

  constructor() {
    // Do stuff
  }

  ngOnInit() {
    console.log('Hello EET');
  }

}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/eet/eet.component.ts